import { useEffect } from 'react';
import { apiCall } from './auth';

// Cada produção já tem o seu cliente: as telas de produção não deixam editar o cliente,
// ele vem sempre da produção escolhida.
export async function clienteDaProducao(producaoId) {
  const id = parseInt(producaoId, 10);
  if (!id) return null;
  try {
    const producao = await apiCall(`Producoes/${id}`);
    return producao?.clienteId ?? producao?.ClienteId ?? null;
  } catch {
    return null;
  }
}

// Quando a produção muda, chama onCliente com o cliente dela (se a produção tiver cliente)
export function useClienteDaProducao(producaoId, onCliente) {
  useEffect(() => {
    if (!producaoId) return;
    let cancelado = false;
    clienteDaProducao(producaoId).then(clienteId => {
      if (!cancelado && clienteId != null) onCliente(clienteId);
    });
    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [producaoId]);
}
